import React from "react";
import { useSearchParams } from "react-router-dom";

const MasterInput = ({ field, formData, handleChange, imagePreview, signaturePreview,validationError,part }) => {
  const validationKeys=Object.keys(validationError)
  const [params]= useSearchParams();


  
  
const disableField = part === "Part-2" ? [
  "first_major_subject",
  "second_major_subject",
  "minor_subject",
  // All other fields from your code:
  "urn",
  "applicant_name",
  "mother_name",
  "father_name",
  "dob",
  "gender",
  "category",
  "sub_category",
  "religion",
  "email",
  "whatsapp_number",
  "applicant_mobile",
  "c_address",
  "p_address",
  "same_as_correspondence",
  "local_guardian_name",
  "local_guardian_contact",
  "local_guardian_address",
  "horizontal_reservation",
  "weightage",
  "nationality",
  "is_minority",
  "is_otherenrollment",
  "is_upresidence",
  "annual_income",
  "income_certificate_no",
  "bank_name",
  "bank_branch",
  "bank_account",
  "bank_isfsc",
  "high_school_year",
  "high_school_board",
  "high_school_name",
  "high_school_roll",
  "high_school_maxmarks",
  "high_school_obtmarks",
  "high_school_percentage",
  "high_school_subject",
  "intermediate_year",
  "intermediate_board",
  "intermediate_name",
  "intermediate_roll",
  "intermediate_maxmarks",
  "intermediate_obtmarks",
  "intermediate_percentage",
  "intermediate_subject",
  "signature",
  "image",
  "has_scholarship",
  "is_casefiled",
  "is_rustigated",
  "is_civilservant",
  "is_ufmeans",
  "aadhar_no"
] : ["aadhar_no","email","applicant_name","applicant_mobile"];


  const hideFields = formData.part === 1 ? ["ug_1styear","ug_board","ug_name","ug_1styear_rollno","ug_1styear_maxmarks","ug_1styear_obtmarks","ug_1styear_percentage","First Year Details"] : []
  
  if (!field) return null;

  if(field.type==="break" && field.breakTitle!==""){

    if(hideFields.includes(field.breakTitle))return


    return <div  style={{ width: "100%" }}>
          <h5 style={{fontSize:'20px',fontWeight:'normal',borderBottom:'1px dotted gray'}}>{field.breakTitle}</h5>
         
        </div>
     
  }


  if(field.type==="break" && field.breakTitle!==""){

    if(hideFields.includes(field.breakTitle))return

    
    return <div  style={{ width: "100%" }}>
          <h5 style={{fontSize:'20px',fontWeight:'normal',borderBottom:'1px dotted gray'}}>{field.breakTitle}</h5>
        </div>
     
  }



  const commonProps = {
    name: field.name,
    value: formData[field.name] || '',
    onChange: handleChange,
    required: true,

   
  };
  





  if (field.type === "file") {
    return (
      <div className="form-input">
        <label>
          <p>{field.label} {field.required==false?"":<span className="required">*</span>} </p>
          <input type="file" name={field.name} accept={field.accept} onChange={handleChange} required />
        </label>
        <span className="error">{validationKeys.includes(field.name)?validationError[field.name][0]:''}</span>
        {field.name === "image" && imagePreview && (
          <img src={imagePreview} alt="Preview" style={{ maxWidth: 150, maxHeight: 150, marginTop: 10 }} />
        )}
        {field.name === "signature" && signaturePreview && (
          <img src={signaturePreview} alt="Signature Preview" style={{ maxWidth: 150, maxHeight: 150, marginTop: 10 }} />
        )}
      </div>
    );
  }

  if (field.type === "select") {

if(hideFields.includes(field.name))return

     
    if(field.name=="second_major_subject" && window.location.toString().split("/")[4]=="bsc"){
     let subs ; 
      if(params.get("subject_group")=="ZBC"){
      subs =["Botany","Chemistry","Zoology"];
    }else if(params.get("subject_group")=="PCM"){
      subs =["Physics","Chemistry","Maths"];
    } else{
       subs =[];
    }
      return (
      <div className="form-input">
       {window.location.toString().split("/")[4]}
        {/* {part}
{}efef
        
       {disabelField.map((item)=>(<p>{item}</p>))} */}
        <label>{field.label}{field.required==false?"":<span className="required">*</span>}</label>
        <select
        
        disabled={disableField.includes(field.name)} 
        
        
        {...commonProps}>

          <option value="">Select</option>
          {subs.map((val, i) => (
            
            <option key={i} value={val}
            
            disabled={
              
              field.name === "first_major_subject" && 
              
              val === "Chemistry"}   >{val}</option>
          ))}
        </select>
        <span className="error">{validationKeys.includes(field.name)?validationError[field.name][0]:''}</span>
      </div>
    );
    }
    return (
      <div className="form-input">
        
        <label>{field.label}{field.required==false?"":<span className="required">*</span>}</label>
        <select 
        
        //  disabled={disableField.includes(field.name)} 
         
         {...commonProps}>
          <option value="">Select</option>
          {field.values.map((val, i) => (
            
            <option key={i} value={val} disabled={field.name === "first_major_subject" && val === "Chemistry"}   >{val}</option>
          ))}
        </select>
        <span className="error">{validationKeys.includes(field.name)?validationError[field.name][0]:''}</span>
      </div>
    );
  }

  if (["text", "email", "tel", "number","date"].includes(field.type)) {

    if(hideFields.includes(field.name))return
    return (
      <div className="form-input">
        <label>{field.label} {field.required==false?"":<span className="required">*</span>}</label>
        <input disabled={disableField.includes(field.name)} type={field.type} {...commonProps}   />
        <span className="error">{validationKeys.includes(field.name)?validationError[field.name][0]:''}</span>
      </div>
    );
  }

  if (field.type === "textarea") {
    return (
      <div className="form-input">
        <label>{field.label}{field.required==false?"":<span className="required">*</span>}</label>
        <textarea disabled={disableField.includes(field.name)} {...commonProps}></textarea>
        <span className="error">{validationKeys.includes(field.name)?validationError[field.name][0]:''}</span>
      </div>
    );
  }

  if (field.type === "radio") {
    return (
      <div className="form-input">
        <label>{field.label}{field.required==false?"":<span className="required">*</span>}</label>
        {field.values.map((val, i) => (
          <label key={i}>
            <input
            disabled={disableField.includes(field.name)}
              type="radio"
              name={field.name}
              value={val}
              checked={formData[field.name] === val}
              onChange={handleChange}
              required
            /> {val}
          </label>
          
        ))}
        <span className="error">{validationKeys.includes(field.name)?validationError[field.name][0]:''}</span>
      </div>
    );
  }

  if (field.type === "checkbox") {
    return (
      <div className="form-input">
        <label>{field.label} {field.required==false?"":<span className="required">*</span>}</label>
        {field.values && Array.isArray(field.values) ? (
          field.values.map((val, i) => (
            <label key={i}>
              <input
              disabled={disableField.includes(field.name)}
                type="checkbox"
                name={field.name}
                value={val}
                checked={formData[field.name]?.includes(val)}
                onChange={handleChange}
              /> {val}
            </label>
          ))
        ) : (
          <label>
            <input
              type="checkbox"
              name={field.name}
              checked={formData[field.name] || false}
              onChange={handleChange}
            /> {field.name}
          </label>
        )}
        <span className="error">{validationKeys.includes(field.name.replace("[]",""))?validationError[field.name.replace("[]","")][0]:''}</span>
      </div>
    );
  }

  if (field.type === "info") {
    return (
      <div className="declaration-text">
        <p>{field.name}</p>
      </div>
    );
  }

  return null;
};

export default MasterInput;
